import { request } from '_api/v1/base/behemoth/client'
import {
    find as _find,
    map as _map,
    uniq as _uniq,
} from 'lodash'

import { getUsers } from '_api/v1/services/user/'
// PushMessages

export const getPushMessages = async (params) => {
    return await request('GET', 'newsletter/push_message/', params)
}

export const getPushMessageById = async (pushMessageId) => {
    return await request('GET', `newsletter/push_message/${pushMessageId}/`)
}

export const getTemplateText = async (data) => {
    return await request('POST', 'newsletter/template/text/', data)
}

export const createPushMessage = async (data) => {
    return await request('POST', 'newsletter/push_message/', data)
}

export const updatePushMessage = async (pushMessageId, data) => {
    return await request('PUT', `newsletter/push_message/${pushMessageId}/`, data)
}

export const deletePushMessage = async (pushMessageId) => {
    return await request('DELETE', `newsletter/push_message/${pushMessageId}/`)
}

export const getListOfTypeTemplate = async (data) => {
    return await request('POST', 'newsletter/template/type/', data)
}

export const getTemplate = async (data) => {
    return await request('POST', '/newsletter/template/', data)
}

export const getTemplateById = async (data) => {
    return await request('POST', '/newsletter/template/detail/', data)
}

// NPS

export const createNPSPushMessage = async (data) => {
    return await request('POST', 'newsletter/nps_message/', data)
}

export const updateNPSPushMessage = async (pushMessageId, data) => {
    return await request('PUT', `newsletter/nps_message/${pushMessageId}/`, data)
}

// Marketing

export const getPushMarketingMessages = async (params) => {
    const response = await request('POST', 'newsletter/resident_category/push_message/list/', params)

    if (response.results?.length) {
        const userIds = _uniq(_map(response.results, (pushMessage) => pushMessage.created_by))

        if (userIds.length) {
            const users = await getUsers({
                id__in: userIds,
            })

            response.results = _map(response.results, (pushMessage) => {
                pushMessage.created_by = _find(users.results, (user) => user.id === pushMessage.created_by)

                return pushMessage
            })
        }
    }

    return response
}

export const createPushMarketingMessage = async (params) => {
    return await request('POST', 'newsletter/resident_category/push_message/', params)
}

export const updatePushMarketingMessage = async (pushMessageId, params) => {
    return await request('POST', `newsletter/resident_category/push_message/${pushMessageId}/update/`, params)
}

export const deletePushMarketingMessage = async (pushMessageId) => {
    return await request('POST', `newsletter/resident_category/push_message/${pushMessageId}/delete/`)
}

export const getResidentCategories = async (data) => {
    return await request('POST', 'newsletter/resident_category/list/', data)
}

export const getPushReceiversCount = async (data) => {
    return await request('POST', 'newsletter/resident_category/receivers_count/', data)
}
